import { CommonModule } from '@angular/common';
import { Component, Optional } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'app-add-link-dialog-box',
	standalone: true,
	imports: [ReactiveFormsModule, CommonModule, MatDialogModule, MatFormFieldModule, MatButtonModule, MatInputModule],
	templateUrl: './add-link-dialog-box.component.html',
	styleUrl: './add-link-dialog-box.component.scss'
})
export class AddLinkDialogBoxComponent {

	addLinkForm: FormGroup;

	constructor(
		@Optional() private dialogRef: MatDialogRef<AddLinkDialogBoxComponent>,
	) {
		this.addLinkForm = new FormGroup({
			url: new FormControl('', [Validators.required, Validators.pattern('https?://.+'),])
		});
	}

	onCancel() {
		this.dialogRef.close();
	}

	onAdd() {
		if (this.addLinkForm.valid) {
			this.dialogRef.close(this.addLinkForm.value.url);
		}
	}
}
